import * as types from './constants';

// Create Code Shipping
export const createCodeShippingRequest = data => (
  { type: types.CREATE_CODE_SHIPPING_REQUEST, payload: data }
);

export const createCodeShippingDone = data => (
  { type: types.CREATE_CODE_SHIPPING_DONE, payload: data }
);

export const createCodeShippingFailed = errors => (
  { type: types.CREATE_CODE_SHIPPING_FAILED, payload: errors }
);

export const createCodeShippingReset = () => (
  { type: types.CREATE_CODE_SHIPPING_RESET }
);